module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAfCAYAAAABZyaKAAAA4klEQVRIie2UMa5BQRiFv+EWV/0qoqESW6C0Cm8FCgvQWIQNWIREZQVKEjageCERxWtE5CiQyPXPHTeREHGSac7MfDNzZuZ3kgioCnSAFlAD4kT/Ckm+5iT1JR0UUBpkEJocgjQeBUhSzpNDLxTUrZzug42BLVB4kPFn7aSSApgBdSAPuEsrRsbAn5RVh8Ayafoy8WljmVkh5svMCjHlJE04h3lVDJQ849fAf8IbOxl3nFHzpxznsyCKgC5QvjHLwK9nwghYJLypVQaaKb++bZWOt8nkC/lCXgvZAXvDP+Kp9if57hOqR47yKgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/FBicon1.png
// module id = 760
// module chunks = 0